import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useAuth } from '../context/AuthContext';
import '../styles/neumorphism.css';

const { FiActivity, FiCheck, FiUsers, FiChevronDown } = FiIcons;

function DepartmentSelector() {
  const { user, userDepartments, currentDepartment, switchDepartment } = useAuth();
  const [isOpen, setIsOpen] = useState(false);

  if (!userDepartments || userDepartments.length <= 1) {
    return null;
  }

  const handleDepartmentSwitch = (department) => {
    switchDepartment(department);
    setIsOpen(false);
  };

  return (
    <div className="relative">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center px-4 py-2 neu-button bg-white text-gray-700 min-w-[200px]"
      >
        <SafeIcon icon={FiActivity} className="w-5 h-5 mr-2 text-orange-600" />
        <div className="flex-1 text-left">
          <div className="text-sm font-medium">{currentDepartment?.name}</div>
          <div className="text-xs text-gray-500">{currentDepartment?.description}</div>
        </div>
        <SafeIcon icon={FiChevronDown} className="w-4 h-4 ml-2" />
      </button>

      {isOpen && (
        <div className="absolute top-full left-0 mt-2 w-full bg-white neu-card z-50">
          <div className="p-3 border-b border-gray-200">
            <h3 className="text-sm font-medium text-gray-900">Abteilung wechseln</h3>
          </div>
          <div className="max-h-64 overflow-y-auto">
            {userDepartments.map((department) => (
              <button
                key={department.id}
                onClick={() => handleDepartmentSwitch(department)}
                className={`w-full flex items-center px-4 py-3 text-left hover:bg-gray-50 transition-colors ${
                  currentDepartment?.id === department.id ? 'bg-orange-50' : ''
                }`}
              >
                <SafeIcon icon={FiActivity} className="w-5 h-5 mr-3 text-gray-400" />
                <div className="flex-1">
                  <div className="text-sm font-medium text-gray-900">{department.name}</div>
                  <div className="text-xs text-gray-500">{department.description}</div>
                </div>
                {currentDepartment?.id === department.id && (
                  <SafeIcon icon={FiCheck} className="w-5 h-5 text-orange-600" />
                )}
              </button>
            ))}
          </div>
        </div>
      )}

      {/* Backdrop */}
      {isOpen && (
        <div className="fixed inset-0 z-40" onClick={() => setIsOpen(false)} />
      )}
    </div>
  );
}

export default DepartmentSelector;